import {
  compareSnapshot,
  createBackup,
  exportSnapshot,
  listSnapshots,
  restoreSnapshot,
} from "@/services/api/app/office/recovery/entraId/object";
import files from "@/store/app/entraId/recovery/entraId";
import exports from "@/store/app/entraId/recovery/exports";

const defaultState = () => ({
  userMap: {},
  listRegions: {},
});

export default {
  namespaced: true,
  actions: {
    createBackup({commit}, userId) {
      return createBackup(userId);
    },
    listSnapshots({commit}, {date, dateTo}) {
      return listSnapshots({date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    compareSnapshot({}, data) {
      return compareSnapshot(data);
    },
  },

  mutations: {
    setUser(state, user) {
      state.userMap = {
        ...state.userMap,
        [user.userId]: user
      };
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
  },

  getters: {
    getUserById: (state) => (id) => {
      return state.userMap[id];
    },
  },

  state: defaultState,

  modules: {
    files,
    exports,
  }
}
